import React from 'react';
import Icon from '../../shared/Icon';
import Select from '../../shared/Select';
import { plural } from '../../../../models/LibraryModel';
import '../../Library/Library.css'; // the Library's search, select and count line

/**
 * The scenarios' search and visibility filter, with the count line under them
 * (PRD-1701). It stays mounted through no results, so the search keeps its
 * focus and caret; with nothing matching, the count line carries the way out.
 */
function ScenariosFilters({ filters, count, total, searchRef, onFilterChange, onClear }) {
  const searching = !!filters.search.trim();
  return (
    <>
      <div className="library-toolbar-left scenarios-filters">
        <div className="library-search">
          <Icon name="magnifying-glass" size={14} className="library-search-icon" />
          <input
            ref={searchRef}
            type="text"
            className="resui-input library-search-input"
            placeholder="Search scenarios…"
            aria-label="Search scenarios"
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
          />
        </div>
        <Select
          ariaLabel="Filter by visibility"
          value={filters.visibility}
          options={[{ value: 'active', label: 'Active' }, { value: 'archived', label: 'Archived' }, { value: 'all', label: 'All' }]}
          onChange={(v) => onFilterChange('visibility', v)}
        />
      </div>

      <p className="library-count-line" aria-live="polite">
        {count ? (
          `${count} of ${total} ${plural(total, 'scenario', 'scenarios')}${searching ? ' found' : ''}`
        ) : (
          <>
            No scenarios found.{' '}
            <button type="button" className="resui-link" onClick={onClear}>Clear search and filters</button>
          </>
        )}
      </p>
    </>
  );
}

export default ScenariosFilters;
